// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__295pg","name":"styles_name__11IUV","phone":"styles_phone__3x-pt"};